import { render, staticRenderFns } from "./hotLine.vue?vue&type=template&id=71c36a7a&scoped=true&"
import script from "./hotLine.vue?vue&type=script&lang=js&"
export * from "./hotLine.vue?vue&type=script&lang=js&"
import style0 from "./hotLine.vue?vue&type=style&index=0&id=71c36a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c36a7a",
  null
  
)

export default component.exports